import { ArrowRight } from 'lucide-react';
import { Check } from 'lucide-react';
import {Navbar} from "../../../components/navbar/navbar";
import React, {useEffect, useMemo, useRef, useState} from "react";

import './Options_BLE.scss'
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../store/store";
import {User} from "../../../types/user";
import {Bandeau_user} from "../../../components/sidebar/bandeau_user/bandeau_user";
import {BleClient, dataViewToText, numbersToDataView, textToDataView} from '@capacitor-community/bluetooth-le';
import {Switch, TextInput} from "@mantine/core";
import {LoadingButton} from "../../../components/loading_button/loading_button";
import {setMobile_sidebar_icon} from "../../../store/interfaceSlice";
import image_push from "../Cycles/img_push.webp"

export function Options_BLE() {

    const [statut, setStatut] = useState<string>("En attente");
    const statutRef = useRef<string>("En attente");

    // Update both when needed
    const updateStatut = (newStatut: string) => {
        setStatut(newStatut);
        statutRef.current = newStatut;
    };

    const [ssid, setSsid] = useState("");
    const [wpas, setWpas] = useState("");

    const [input_mode, setInput_mode] = useState<"wifi" | "lora">("wifi");

    const get_mac = useRef<string | null>(null);
    const get_ssid = useRef<string | null>(null);
    const get_mode = useRef<string | null>(null);
    const [error_bluetooth, setError_bluetooth] = useState<string | null>(null);

    const [btn_loading, setBtn_loading] = useState<string>("");

    const timeout = (ms: number) =>
        new Promise((resolve) => setTimeout(resolve, ms));

    async function readMacAdress(): Promise<void> {
        setError_bluetooth(null);
        try {
            setBtn_loading("mac");
            const SERVICE = '6E400001-B5A3-F393-E0A9-E50E24DCCA9E';
            const READ_CHARACTERISTIC = '6E400003-B5A3-F393-E0A9-E50E24DCCA9E'; //Lecture de la réponse des requetes
            const WRITE_CHARACTERISTIC = '6E400002-B5A3-F393-E0A9-E50E24DCCA9E'; //Ecriture des commandes


            await BleClient.initialize({androidNeverForLocation: true});

            const device = await BleClient.requestDevice({
                services: [SERVICE],
            });

            // connect to device, the onDisconnect callback is optional
            await BleClient.connect(device.deviceId, (deviceId) => onDisconnect(deviceId));
            console.log('connected to device', device);
            updateStatut("Connecté à l'appareil " + device.name);

            get_mac.current = null;
            get_mode.current = null;
            get_ssid.current = null;


            // disconnect after 60 sec
            let auto_deco = setTimeout(async () => {
                await BleClient.stopNotifications(device.deviceId, SERVICE, READ_CHARACTERISTIC);
                await BleClient.disconnect(device.deviceId);
                console.log('disconnected from device', device);
                updateStatut("Déconnecté après 30 secondes. Une erreur est sûrement survenue.");
                setBtn_loading("");
            }, 30000);

            await BleClient.startNotifications(
                device.deviceId,
                SERVICE,
                READ_CHARACTERISTIC,
                async (value) => {
                    console.log('NOTIF : ' + dataViewToText(value));
                    console.log('NOTIF OBJ : ' + JSON.stringify(dataViewToText(value)));
                    console.log('MAC STATE : ' + JSON.stringify(get_mac));
                    console.log('v3');
                    if (!get_mac.current) {
                        console.log("get_mac : " + dataViewToText(value))
                        get_mac.current = dataViewToText(value) ?? "Erreur"

                        await timeout(500);
                        await BleClient.write(device.deviceId, SERVICE, WRITE_CHARACTERISTIC, textToDataView("BHC22,?=WSSD,\r\n"));
                        console.log('written ?=WSSD');
                    } else if (!get_ssid.current) {
                        console.log("get_ssid")
                        get_ssid.current = dataViewToText(value) ?? "Erreur"
                        setSsid(dataViewToText(value))


                        await timeout(500);
                        await BleClient.write(device.deviceId, SERVICE, WRITE_CHARACTERISTIC, textToDataView("BHC22,?=MODE,\r\n"));
                        console.log('written ?=MODE');
                    } else if (!get_mode.current) {
                        console.log("get_mode")
                        get_mode.current = dataViewToText(value) ?? "Erreur"
                        clearTimeout(auto_deco);
                        BleClient.stopNotifications(device.deviceId, SERVICE, READ_CHARACTERISTIC);
                        BleClient.disconnect(device.deviceId);
                        setBtn_loading("");
                    }
                },
            );
            await timeout(500);

            await BleClient.write(device.deviceId, SERVICE, WRITE_CHARACTERISTIC, textToDataView("BHC22,?=WMAC,\r\n"));
            console.log('written ?=WMAC');

            //
            // const result = await BleClient.read(device.deviceId, SERVICE, READ_CHARACTERISTIC);
            // console.log('READ : ', dataViewToText(result));
            // setReponse("Réponse" + dataViewToText(result));

        } catch (error) {
            console.error(error);
            setError_bluetooth(JSON.stringify(error));
            setBtn_loading("");
        }
    }

    async function sendConfig(): Promise<void> {
        
        setError_bluetooth(null);
        try {
            setBtn_loading("setwifi");
            const SERVICE = '6E400001-B5A3-F393-E0A9-E50E24DCCA9E';
            const READ_CHARACTERISTIC = '6E400003-B5A3-F393-E0A9-E50E24DCCA9E'; //Lecture de la réponse des requetes
            const WRITE_CHARACTERISTIC = '6E400002-B5A3-F393-E0A9-E50E24DCCA9E'; //Ecriture des commandes


            await BleClient.initialize({androidNeverForLocation: true});

            const device = await BleClient.requestDevice({
                services: [SERVICE],
            });

            // connect to device, the onDisconnect callback is optional
            await BleClient.connect(device.deviceId, (deviceId) => onDisconnect(deviceId));
            console.log('connected to device', device);
            updateStatut("Connecté à l'appareil " + device.name);
            
            await timeout(500);

            if (input_mode === "wifi") {
                if (ssid?.length > 0) {
                    await BleClient.write(device.deviceId, SERVICE, WRITE_CHARACTERISTIC, textToDataView("BHC22,WSSD," + ssid + "\r\n"));
                    console.log('written WSSD'); 
                    await timeout(1000);
                }
                if (wpas?.length > 0) {
                    await BleClient.write(device.deviceId, SERVICE, WRITE_CHARACTERISTIC, textToDataView("BHC22,WPAS," + wpas + "\r\n"));
                    console.log('written WPAS');
                    await timeout(1000);
                }


                await BleClient.write(device.deviceId, SERVICE, WRITE_CHARACTERISTIC, textToDataView("BHC22,MODE,0\r\n"));
                console.log('written MODE 0 Wifi');
            }
            if (input_mode === "lora") {
                await timeout(1000);
                await BleClient.write(device.deviceId, SERVICE, WRITE_CHARACTERISTIC, textToDataView("BHC22,MODE,1\r\n"));
                console.log('written MODE 1 Lora');
            }


            await timeout(1000);
            console.log('disconnected from device', device);
            setBtn_loading("");

            await BleClient.disconnect(device.deviceId);
            updateStatut("Effectué");

        } catch (error) {
            console.error(error);
            setBtn_loading("");
        }
    }

    const dispatch = useDispatch();
    dispatch(setMobile_sidebar_icon("aucun"))

    function onDisconnect(deviceId: string): void {
        console.log(`device ${deviceId} disconnected`);
        setStatut('Appareil déconnecté, une erreur est peut-etre survenue. Merci de ré-essayer.');
        
        setBtn_loading("");
    }

    function checkForcerWifi() {
        return true;
        //return get_ssid.current && get_ssid.current.length > 0 && wpas === "";
    }

    return (
        <div className={"app"}>
            <Navbar/>

            <div className={"content content-fullwidth en-tete-pages page-ble"}>
                <div className={"en-ligne en-tete-page"}>
                    <div className={"titre"}>
                        <h1>Options Bluetooth</h1>
                        <p>
                            Cette page vous permet de communiquer en Bluetooth avec vos appareil pour les
                            configurer ou obtenir des informations.
                        </p>
                    </div>

                    <div className={"mini-sidebar"}>
                        <Bandeau_user/>
                    </div>
                </div>

                <div className={'en-ligne'} style={{marginTop: "1rem"}}>
                    <p className={"notice grey"}>Pour mettre votre enregistreur en mode Bluetooth, appuyer sur son
                        bouton jusqu'à ce que la LED
                        devienne rouge.
                        Il sera ensuite détectable pour les actions ci-dessous avec le nom "Freshtime Evo_XXXX"</p>
                </div>

                <div className={'en-ligne'}>
                    <img id={"image_demo"} src={image_push} alt=""/>
                </div>
                <h3 style={{marginTop: "1rem"}}>1. Récupération des informations : </h3>
                <div style={{marginTop: "1rem"}}>
                    <LoadingButton is_loading={btn_loading === "mac"} onClick={readMacAdress}>
                        <ArrowRight/> Récupérer les informations de l'appareil (Wifi/Lora et adresse
                        Mac)</LoadingButton>
                    {get_ssid.current && <p style={{marginTop: "1rem"}}>Wifi SSID : {get_ssid.current}</p>}
                    {get_mac.current &&
                        <p style={{marginTop: "1rem"}}>Addresse MAC : {get_mac?.current?.slice(0, 17)}</p>}
                    {get_mode.current && <p style={{marginTop: "1rem"}}>Mode : {get_mode.current}</p>}
                </div>
                <h3 style={{marginTop: "1rem"}}>2. Configuration de l'appareil : </h3>
                <div className={'en-ligne'} style={{marginTop: "1rem"}}>
                    <p>L'appareil doit communiquer en : </p>
                    <div className={'en-ligne'}>
                        <button className={input_mode === "lora" ? "vert" : "sec"}
                                onClick={() => setInput_mode("lora")}>
                            {input_mode === "lora" && <Check/>} Lora
                        </button>
                        <button className={input_mode === "wifi" ? "vert" : "sec"}
                                onClick={() => setInput_mode("wifi")}>
                            {input_mode === "wifi" && <Check/>} Wifi
                        </button>
                    </div>

                </div>
                {input_mode === "wifi" ? (
                    <>
                        <TextInput
                            label={"SSID du Wifi"}
                            value={ssid}
                            onChange={e => setSsid(e.target.value)}
                            placeholder={"Laisser vide pour utiliser le SSID déjà enregistré dans l'enregistreur"}
                        />
                        <TextInput
                            label={"Mot de passe Wifi"}
                            value={wpas}
                            onChange={e => setWpas(e.target.value)}
                            placeholder={"Laisser vide pour utiliser le mot de passe déjà enregistré dans l'enregistreur"}
                        />

                        <LoadingButton is_loading={btn_loading === "setwifi"}
                                       onClick={sendConfig} style={{marginTop: "1rem"}}>
                            <ArrowRight/> Envoyer les coordonnées Wifi et passer en mode Wifi
                        </LoadingButton>
                    </>
                ) : (
                    <LoadingButton is_loading={btn_loading === "setwifi"}
                                   onClick={sendConfig} style={{marginTop: "1rem"}}>
                        <ArrowRight/> Envoyer la configuration à l'appareil
                    </LoadingButton>
                )}


                {statut === "Effectué" && (
                    <div className={"inline-tag green"} style={{marginTop: "1rem"}}>
                        Vos réglages ont été envoyés à l'appareil.
                        <br/>
                        Si l'appareil à réussi à se connecter, vous devriez le voir s'actualiser sur la plateforme
                        dans
                        la minute.
                    </div>
                )}

                <p className={"inline-tag"}>Statut connexion bluetooth : <strong>{statut}</strong></p>
                {error_bluetooth && (
                    <>
                        <p className={"inline-tag"}>Une erreur est survenue : <strong>{error_bluetooth}</strong></p>
                        <p className={"inline-tag"}>Merci de ré-essayer</p>
                    </>
                )}

            </div>
        </div>

    )
        ;
}
